import { DateFormat } from '../const/date-formatter/date-formatter.const'
import moment from 'moment'

export class EventModel {
  id: string
  organiserId: string
  name: string
  description: string
  fromDateTime: any
  toDateTime: any
  deadlineDateTime: any
  city: string
  address: string
  maxNumberOfAttendees: number
  numberOfAttendees: number
  money: number
  cabbage: number
  salt: number
  isApproved: boolean
  reasonOfDelete: string

  // Add optional isRegistered to prevent needing (event as any) in the template
  isRegistered?: boolean

  constructor(params?: {
    id: string
    organiserId: string
    name: string
    description: string
    fromDateTime: Date
    toDateTime: Date
    deadlineDateTime: Date
    city: string
    address: string
    maxNumberOfAttendees: number
    numberOfAttendees: number
    money: number
    cabbage: number
    salt: number
    isApproved: boolean
    reasonOfDelete: string
    isRegistered?: boolean
  }) {
    if (params) {
      this.id = params.id != null ? params.id : null
      this.organiserId = params.organiserId != null ? params.organiserId : null
      this.name = params.name != null ? params.name : null
      this.description = params.description != null ? params.description : null
      this.fromDateTime = params.fromDateTime != null ? moment(params.fromDateTime).format(DateFormat.DEFAULT) : null
      this.toDateTime = params.toDateTime != null ? moment(params.toDateTime).format(DateFormat.DEFAULT) : null
      this.deadlineDateTime =
        params.deadlineDateTime != null ? moment(params.deadlineDateTime).format(DateFormat.DEFAULT) : null
      this.city = params.city != null ? params.city : null
      this.address = params.address != null ? params.address : null
      this.maxNumberOfAttendees = params.maxNumberOfAttendees != null ? params.maxNumberOfAttendees : null
      this.numberOfAttendees = params.numberOfAttendees != null ? params.numberOfAttendees : 0
      this.money = params.money != null ? params.money : 0
      this.cabbage = params.cabbage != null ? params.cabbage : 0
      this.salt = params.salt != null ? params.salt : 0
      this.isApproved = params.isApproved != null ? params.isApproved : false
      this.reasonOfDelete = params.reasonOfDelete != null ? params.reasonOfDelete : null

      // optional
      this.isRegistered = params.isRegistered != null ? params.isRegistered : false
    }
  }
}

export class EventModelDto {
  name: string
  description: string
  fromDateTime: any
  toDateTime: any
  deadlineDateTime: any
  city: string
  address: string
  maxNumberOfAttendees: number
  numberOfAttendees: number
  organiserId: string
  money: number
  cabbage: number
  salt: number
  isApproved: boolean

  constructor(params?: {
    name: string
    description: string
    fromDateTime: Date
    toDateTime: Date
    deadlineDateTime: Date
    city: string
    address: string
    maxNumberOfAttendees: number
    numberOfAttendees: number
    organiserId: string
    money: number
    cabbage: number
    salt: number
    isApproved: boolean
  }) {
    if (params) {
      this.name = params.name != null ? params.name : null
      this.description = params.description != null ? params.description : null
      this.fromDateTime = params.fromDateTime != null ? moment(params.fromDateTime).format(DateFormat.DEFAULT) : null
      this.toDateTime = params.toDateTime != null ? moment(params.toDateTime).format(DateFormat.DEFAULT) : null
      this.deadlineDateTime =
        params.deadlineDateTime != null ? moment(params.deadlineDateTime).format(DateFormat.DEFAULT) : null
      this.city = params.city != null ? params.city : null
      this.address = params.address != null ? params.address : null
      this.maxNumberOfAttendees = params.maxNumberOfAttendees != null ? params.maxNumberOfAttendees : null
      this.numberOfAttendees = params.numberOfAttendees != null ? params.numberOfAttendees : 0
      this.organiserId = params.organiserId != null ? params.organiserId : null
      this.money = params.money != null ? params.money : 0
      this.cabbage = params.cabbage != null ? params.cabbage : 0
      this.salt = params.salt != null ? params.salt : 0
      this.isApproved = params.isApproved != null ? params.isApproved : false
    }
  }
}

export interface IEvent {
  name: string
  description: string
  fromDateTime: any
  toDateTime: any
  deadlineDateTime: any
  city: string
  address: string
  maxNumberOfAttendees: number
  organiserId: string
  money: number
  cabbage: number
  salt: number
  isApproved: boolean
}